import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import "./contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    tel: "",
    message: "",
  });

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          alert("Email sent successfully!");
          setFormData({ name: "", email: "", tel: "", message: "" });
        },
        (error) => {
          alert("Failed to send email: " + error.text);
        }
      );
  };

  return (
    <div className="contact-page">
      <div className="contact-main-layout">
        <section className="factory-contact-panel" aria-labelledby="factory-title">
          <p className="contact-eyebrow">POWER BUNCH FACTORY</p>
          <h1 id="factory-title">โรงงาน<br />Power Bunch</h1>
          <p className="factory-intro">
            ติดต่อทีมผู้เชี่ยวชาญของเราเพื่อขอคำปรึกษาเรื่องระบบครัว
            งานสแตนเลส และงานติดตั้งครบวงจร
          </p>

          <div className="factory-info-grid">
            <div>
              <h2>โรงงานเปิดบริการ</h2>
              <p>
                วันจันทร์ - เสาร์<br />
                เวลา 8:30–17:00
              </p>
            </div>
            <div>
              <h2>ที่อยู่</h2>
              <p>
                เลขที่ 4 ถนนเคหะร่มเกล้า<br />
                แขวงคลองสองต้นนุ่น เขตลาดกระบัง<br />
                กรุงเทพฯ 10520
              </p>
            </div>
          </div>

          <div className="factory-contact-list">
            <div>
              <span>โทร</span>
              <a href="tel:0809044884">080-904-4884</a>
            </div>
            <div>
              <span>อีเมล</span>
              <a href="mailto:factoryoutletshop@hotmail.com">factoryoutletshop@hotmail.com</a>
            </div>
            <div>
              <span>ไลน์</span>
              <a href="https://line.me/ti/p/~srt6767" target="_blank" rel="noopener noreferrer">
                srt6767 / @factoryoutletshop2
              </a>
            </div>
          </div>

          <a
            href="https://maps.app.goo.gl/QoSdyThRABbnMUc16"
            target="_blank"
            rel="noopener noreferrer"
            className="factory-direction-link"
          >
            เปิดเส้นทางใน Google Maps <FaArrowRight />
          </a>
        </section>

        <section className="contact-form-panel" aria-labelledby="contact-form-title">
          <p className="contact-eyebrow">GET IN TOUCH</p>
          <h2 id="contact-form-title">ติดต่อเรา</h2>
          <p className="form-intro">กรอกข้อมูลด้านล่าง แล้วทีมงานจะติดต่อกลับโดยเร็วที่สุด</p>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="contact-form-row">
              <div className="contact-field">
                <label htmlFor="name">ชื่อ*</label>
                <input id="name" type="text" name="name" value={formData.name} placeholder="ชื่อของคุณ" onChange={handleChange} required />
              </div>
              <div className="contact-field">
                <label htmlFor="tel">เบอร์ติดต่อ*</label>
                <input id="tel" type="tel" name="tel" value={formData.tel} placeholder="เบอร์โทรศัพท์" onChange={handleChange} required />
              </div>
            </div>

            <div className="contact-field">
              <label htmlFor="email">อีเมล*</label>
              <input id="email" type="email" name="email" value={formData.email} placeholder="example@email.com" onChange={handleChange} required />
            </div>

            <div className="contact-field">
              <label htmlFor="message">สินค้าหรือบริการที่สนใจ*</label>
              <textarea id="message" name="message" value={formData.message} placeholder="บอกเราเกี่ยวกับงานที่คุณต้องการ" onChange={handleChange} required />
            </div>

            <button type="submit">ขอคำปรึกษาจากเรา <FaArrowRight /></button>
          </form>
        </section>
      </div>

      <section className="factory-map-section" aria-labelledby="map-title">
        <div className="factory-map-heading">
          <div>
            <p className="contact-eyebrow">OUR LOCATION</p>
            <h2 id="map-title">แผนที่โรงงาน Power Bunch</h2>
          </div>
          <p>ถนนเคหะร่มเกล้า เขตลาดกระบัง กรุงเทพฯ</p>
        </div>

        <div className="factory-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d484.39888891673405!2d100.71969622560954!3d13.76734578885759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d67000a1cdf1f%3A0xa4928ecb68377db2!2z4Lia4Lij4Li04Lip4Lix4LiXIOC5gOC4nuC4suC5gOC4p-C4reC4o-C5jCDguJrguLHguYnguJnguIrguYwg4LiI4Liz4LiB4Lix4LiU!5e0!3m2!1sth!2sth!4v1787514521095!5m2!1sth!2sth"
            title="แผนที่โรงงาน Power Bunch"
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </section>
    </div>
  );
}

export default Contact;
